module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/join-option-online-18c4809a162cee9594674f3912036277.jpg";